import { ReactElement } from "react";

import { ICatalogueSetItem } from "../../../../apis/useGetCatalogueData/types";
import { Nullable } from "../../../../common/types/types";
import Condition from "../../../../components/Conditional/Condition";
import PDPSetItem from "./PDPSetItem";

interface IProps {
	setitems?: Nullable<ICatalogueSetItem[]>;
	selectedSetItems?: Nullable<ICatalogueSetItem>[];
}

const PDPSetItems = ({ setitems, selectedSetItems = [] }: IProps): ReactElement => {
	return (
		<Condition check={!!setitems?.length}>
			<div className="PDPSetItemsContainer">
				{setitems?.map((setitem, idx) => (
					<PDPSetItem
						idx={idx}
						setitem={setitem}
						selectedSetItem={selectedSetItems[idx]}
						key={setitem.external_id}
					/>
				))}
			</div>
		</Condition>
	);
};

export default PDPSetItems;
